import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation } from '@app/api';
import { AcceptedParticipationCard } from '../../Home/components/AcceptedParticipationCard';
import { EmptyState } from './EmptyState';
import InboxRed from '@app/illu/Small/InboxRed.svg';
import { StudiesCardContainer } from './StudiesCardContainer';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,
    minWidth: 'auto',
    overflow: 'hidden',
    borderRadius: theme.borderRadius.large,
    marginBottom: theme.marginBase,
    [theme.media.homeScreen]: {
      width: '100%',
      minWidth: 'auto',
    },
  },
}));

interface Props {
  participations: Participation[];
}

export const StudiesAccepted = ({ participations }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const noParticipation = !participations || participations.length === 0;

  return (
    <StudiesCardContainer noParticipation={noParticipation}>
      {noParticipation ? (
        <EmptyState
          illustration={InboxRed}
          alt="Inbox"
          title={t('studies.empty.accepted.title')}
          description={t('studies.empty.accepted.description')}
        />
      ) : (
        participations.map((participation, num) => {
          return (
            <AcceptedParticipationCard
              key={participation.id}
              participation={participation}
              className={classes.cardContainer}
              variant={num === 0 ? 'plain' : 'transparent'}
            />
          );
        })
      )}
    </StudiesCardContainer>
  );
};
